import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Bell, Calendar, Clock } from "lucide-react";
import { useReminders } from "@/hooks/use-reminders";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

export const RemindersSection = () => {
  const { reminders, isLoading } = useReminders();

  if (isLoading) {
    return null;
  }

  if (!reminders.length) {
    return null;
  }

  return (
    <Card className="bg-gradient-to-br from-amber-50 to-amber-100">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Bell className="h-5 w-5 text-amber-600" />
          Rappels importants
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {reminders.map((reminder) => (
            <div
              key={reminder.id}
              className="flex items-center justify-between p-4 rounded-lg bg-white/50"
            >
              <div className="space-y-1">
                <h4 className="font-semibold text-amber-900">{reminder.title}</h4>
                <p className="text-sm text-amber-600">{reminder.content}</p>
                <p className="text-xs text-amber-600/80 flex items-center gap-2">
                  <Clock className="h-3 w-3" />
                  {format(new Date(reminder.created_at), "PPp", { locale: fr })}
                </p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};